// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__xdQkF","spinner":"MGLoader_spinner__q29qz","mg-loader-spin":"MGLoader_mg-loader-spin__axntv"};